const FP_KEY = 'blog_device_fp'

function simpleHash(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash).toString(16).padStart(8, '0')
}

/** 生成并缓存浏览器设备指纹，供登录/注册审计上报 */
export function getDeviceFingerprint() {
  try {
    const cached = localStorage.getItem(FP_KEY)
    if (cached) return cached

    const raw = [
      navigator.userAgent,
      navigator.language,
      screen.width,
      screen.height,
      screen.colorDepth,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      new Date().getTimezoneOffset()
    ].join('|')

    const fp = simpleHash(raw)
    localStorage.setItem(FP_KEY, fp)
    return fp
  } catch {
    return 'unknown'
  }
}
